import { render, staticRenderFns } from "./AdminOrdersScreen.vue?vue&type=template&id=a0373ae0&scoped=true&"
import script from "./AdminOrdersScreen.vue?vue&type=script&lang=js&"
export * from "./AdminOrdersScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrdersScreen.vue?vue&type=style&index=0&id=a0373ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0373ae0",
  null
  
)

export default component.exports